import { LOCAL_STORAGE } from '@/constant';
import { postCommonConfigGetRedNum } from '@/services/yizhe-web/gonggongfenlei';
import { postBackendRoleGetWebMenus } from '@/services/yizhe-web/shouyeguanli';
import { useCallback, useEffect, useState } from 'react';

interface CommonStateType extends commonApi.BaobanPcGetConfigResponse {
  loading: boolean;
  error: any;
}

const initState: CommonStateType = {
  loading: true,
  error: undefined,
};

export default () => {
  const [state, setState] = useState(initState);
  const info: any = JSON.parse(localStorage.getItem(LOCAL_STORAGE.tokenInfo) || '{}');
  console.log('🚀 ~ file: useCommonModel.ts ~ line 19 ~ info', info);
  const getMenus = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: undefined }));
    try {
      if (info.token) {
        const res = await postBackendRoleGetWebMenus({});
        setState((s) => ({ ...s, currentMenus: res.data, loading: false }));
      }
    } catch (e) {
      setState((s) => ({ ...s, error: e, loading: false }));
    }
  }, []);

  const getRedNum = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: undefined }));
    try {
      if (info.token) {
        const res = await postCommonConfigGetRedNum({});
        setState((s) => ({ ...s, redNum: res.data, loading: false }));
      }
    } catch (e) {
      setState((s) => ({ ...s, error: e, loading: false }));
    }
  }, []);

  useEffect(() => {
    // getMenus();
    // getRedNum();
  }, []);

  return {
    ...state,
    getMenus,
    getRedNum,
  };
};
